import cn from 'clsx';
import React, { ButtonHTMLAttributes } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/pro-regular-svg-icons';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  direction: 'left' | 'right';
};

export default function SliderButton({ disabled, direction, className, ...props }: Props) {
  const classes = cn(
    'w-10 h-10 flex flex-col items-center justify-center rounded-full text-slate-500 bg-slate-50',
    {
      'hover:text-slate-700 active:text-slate-900': !disabled,
      'hover:bg-slate-100 active:bg-slate-200': !disabled,
      'opacity-25': disabled,
    },
    className
  );

  return (
    <button disabled={disabled} className={classes} {...props}>
      <FontAwesomeIcon icon={direction === 'left' ? faAngleLeft : faAngleRight} size="lg" />
    </button>
  );
}
